import React from 'react'
import './Contact.css'
const Contact = () => {
    return (
        <div className="social-links">
        <p>CONTACT</p>
		<a href="https://github.com/Achyuthc"><i class="fab fa-github"></i></a>
		<a href="https://www.linkedin.com/in/achyuth-chowdary-d-a-5629b7211"><i class="fab fa-linkedin-in"></i></a>
		
		<a href="https://www.hackerrank.com/achyuthchowdary3"><i class="fab fa-hackerrank"></i></a>
		<a href="https://valueinvestingvi.blogspot.com/2021/06/value-investing-and-assets.html?m=1" > <i class="fab fa-blogger"></i> </a>
		<p>Copyright Achyuth Chowdary D A</p>
		<p>achyuthchowdary30@gmail.com</p>
	</div>

    )
}

export default Contact

